import type { ComponentPropsWithoutRef } from "react";
import classnames from "classnames";

/** Class to hide PII from FullStory */
/** See more: https://help.fullstory.com/hc/en-us/articles/360020623574-How-do-I-protect-my-users-privacy-in-Fullstory */
export const SENSITIVE_CLASS = "fs-exclude";

function SensitiveLabel(props: ComponentPropsWithoutRef<"label">) {
  const cx = classnames(props.className, SENSITIVE_CLASS);
  return <label {...props} className={cx} />;
}

export default SensitiveLabel;
